import { Box } from "@chakra-ui/react";
import { useConfigurationMenu } from "@raiden/library/hooks/useConfigurationMenu";
import { MenuItem } from "./MenuItem";

/**
 * @typedef {Object} Props
 * @property {() => void} onClickSearch
 * @property {() => void} onClickMenu
 */
/**
 * @param {Props} props
 */
export function MenuMobile({ onClickSearch, onClickMenu }) {
  const { menu } = useConfigurationMenu({ alias: "header" });

  return (
    <Box>
      {menu && menu.items.length > 0 && (
        <>
          {menu.items.map((item, index) => (
            <MenuItem
              menuItem={item}
              onClickSearch={onClickSearch}
              onClickMenu={onClickMenu}
              key={index}
            />
          ))}
        </>
      )}
    </Box>
  );
}
